import React from 'react';
import { Wallet3Line } from '@datanomik/core-ui/icons';
import { TariffsModuleRoute } from './TariffsModuleRoute';

/**
 * The "Tarifas" menu entry — one route serving BOTH modules.
 *
 * {@link TariffsModuleRoute} picks between the rebuilt module (the default) and the previous one (an opt-out from the
 * module's settings menu, persisted per browser). Keeping it a single route is the point: the path for "tarifas" is the
 * same for everyone, so a link pasted into Slack opens whichever version the reader chose instead of dead-ending on a
 * screen they never use.
 */
export const getTariffsRoutes = () => [
  {
    path: '',
    key: 'tariffs',
    label: 'Tarifas',
    description: 'Auditoria de tarifas bancárias.',
    element: <TariffsModuleRoute />,
    icon: <Wallet3Line />,
  },
];
